const MainDashboard = () => {
  return "در حال پیاده سازی";
};

export default MainDashboard;
